import { useExperienceVariants } from '~/lib/cohesion/Monarch/useExperienceVariants';

/**
 * Custom hook to handle variant IDs across the application
 */
export const useVariantIds = () => {
  const { hasVariant } = useExperienceVariants();

  return {
    isDarkMode: hasVariant('e3aa8f5b-9978-4b69-bc38-dbeb9478b037'),
    // Add more variant ID checks here as needed
  };
};
